const publicRoutes = new Set(["pw-reset"]);

export const isPublicRoute = (path = "") => {
  const normalizedPath = path.replace(/^\/+|\/+$/g, "");
  return publicRoutes.has(normalizedPath);
};
